export default `
  mutation resetBillingCycle($subscriptionId: String!) {
    resetBillingCycle(subscriptionId: $subscriptionId) {
      success
      message
      clientSecret
    }
  }
`
